var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "42px",
    viewBox: "0 0 46 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45897199,3.70447353 C-1.15563232,8.64145072 -1.15034825,16.5669158 3.45897199,21.5077994 L22.2804247,41.6870452 C22.4652676,41.8868157 22.7223928,42 22.9913763,42 C23.2603598,42 23.5174849,41.8868157 23.7023278,41.6870452 C29.9821471,34.9684495 36.2591785,28.2422009 42.5390467,21.5234551 C47.1536511,16.5863929 47.1536511,8.65716144 42.5390467,3.72010422 C37.9244911,-1.216948 30.3810452,-1.21705804 25.7664407,3.72010422 L22.9990088,6.67430463 L20.2316259,3.70447353 C17.9242992,1.23594492 14.8753929,0 11.8376419,0 C8.79989094,0 5.76624976,1.23593992 3.45897199,3.70447353 Z",
    id: "icLikeHS",
    fill: "#CECECE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeHs);
export default __webpack_public_path__ + "static/media/icLikeHS.827b78f64dfa88525009ee9d918f9edd.svg";
export { ForwardRef as ReactComponent };